import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { InspectionPlugin } from '../../shared/models';
import { Observable } from 'rxjs';
import { DataService } from '../../shared/services';

@Injectable()
export class PeripheralInfoFactoryPluginService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updatePeripheralInfo(
    inspectionId: string,
    pluginId: string,
    peripheralInfos: any[],
    propertyName?: string
  ): Observable<InspectionPlugin> {
    peripheralInfos.forEach((peripheralInfo) => {
      if (!peripheralInfo.Id) {
        peripheralInfo.Id = this.guid();
      }
    });
    return this.updatePluginConfig(inspectionId, null, pluginId, peripheralInfos, propertyName);
  }
}
